/**
 * JiYu Skin Theme - Global JavaScript
 * 全局交互功能
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all components
  new CartDrawer();
  new MobileMenu();
  new AnnouncementBar();
  new ProductGallery();
  new QuantitySelector();
  new NewsletterPopup();
  new ProductVariants();
});

/**
 * Cart Drawer
 */
class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    if (!this.drawer) return;
    
    this.bindEvents();
  }

  bindEvents() {
    // Open cart
    document.querySelectorAll('[data-cart-toggle], .js-cart-toggle').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close cart
    document.querySelectorAll('[data-cart-close], .js-cart-close').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  open() {
    this.drawer.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateCartCount(cart.item_count);
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
}

/**
 * Mobile Menu
 */
class MobileMenu {
  constructor() {
    this.menu = document.getElementById('mobile-menu');
    this.overlay = document.getElementById('mobile-overlay');
    if (!this.menu) return;
    
    this.bindEvents();
  }

  bindEvents() {
    // Toggle menu
    document.querySelectorAll('[data-menu-toggle], .js-menu-toggle').forEach(btn => {
      btn.addEventListener('click', () => this.toggle());
    });

    // Close menu
    document.querySelectorAll('[data-menu-close], .js-menu-close').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Handle accordion in mobile menu
    this.menu.querySelectorAll('.mobile-menu__accordion').forEach(accordion => {
      const trigger = accordion.querySelector('.mobile-menu__accordion-trigger');
      const content = accordion.querySelector('.mobile-menu__accordion-content');
      
      if (trigger && content) {
        trigger.addEventListener('click', () => {
          accordion.classList.toggle('is-open');
        });
      }
    });
  }

  toggle() {
    if (this.menu.classList.contains('is-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menu.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.menu.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
}

/**
 * Announcement Bar
 */
class AnnouncementBar {
  constructor() {
    this.bar = document.querySelector('.announcement-bar');
    if (!this.bar) return;
    
    this.initSlider();
  }

  initSlider() {
    const slides = this.bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length <= 1) return;

    let currentIndex = 0;
    
    setInterval(() => {
      slides[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add('is-active');
    }, 4000);
  }
}

/**
 * Product Gallery
 */
class ProductGallery {
  constructor() {
    this.gallery = document.querySelector('.product-gallery');
    if (!this.gallery) return;
    
    this.mainImage = this.gallery.querySelector('.product-gallery__image');
    this.thumbs = this.gallery.querySelectorAll('.product-gallery__thumb');
    
    this.bindEvents();
  }

  bindEvents() {
    this.thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const imageUrl = thumb.dataset.imageUrl;
        if (imageUrl && this.mainImage) {
          this.mainImage.src = imageUrl;
          
          // Update active state
          this.thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  }
}

/**
 * Quantity Selector
 */
class QuantitySelector {
  constructor() {
    document.querySelectorAll('.quantity-selector').forEach(selector => {
      this.initSelector(selector);
    });
  }

  initSelector(selector) {
    const input = selector.querySelector('.quantity-input');
    const minusBtn = selector.querySelector('.quantity-minus');
    const plusBtn = selector.querySelector('.quantity-plus');

    if (!input) return;

    minusBtn?.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || 1;
      if (currentValue > 1) {
        input.value = currentValue - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plusBtn?.addEventListener('click', () => {
      const currentValue = parseInt(input.value) || 1;
      input.value = currentValue + 1;
      input.dispatchEvent(new Event('change'));
    });
  }
}

/**
 * Newsletter Popup
 */
class NewsletterPopup {
  constructor() {
    this.popup = document.getElementById('newsletter-popup');
    if (!this.popup) return;
    
    this.hasShown = sessionStorage.getItem('popup_shown');
    
    if (!this.hasShown) {
      setTimeout(() => this.show(), 5000);
    }
    
    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll('[data-popup-close]').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    // Close on overlay click
    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) {
        this.close();
      }
    });
  }

  show() {
    this.popup.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.popup.classList.remove('is-visible');
    document.body.style.overflow = '';
    sessionStorage.setItem('popup_shown', 'true');
  }
}

/**
 * Product Variants
 */
class ProductVariants {
  constructor() {
    this.form = document.querySelector('.product-form');
    if (!this.form) return;
    
    this.variantInput = this.form.querySelector('input[name="id"]');
    this.variantOptions = this.form.querySelectorAll('.variant-option');
    
    this.bindEvents();
  }

  bindEvents() {
    this.variantOptions.forEach(option => {
      option.addEventListener('click', () => {
        const optionIndex = option.dataset.optionIndex;
        const value = option.dataset.value;
        
        // Update selected state
        const siblings = option.closest('.product-variant-options')?.querySelectorAll('.variant-option');
        siblings?.forEach(s => s.classList.remove('is-selected'));
        option.classList.add('is-selected');
        
        // Update variant ID if needed
        this.updateVariant();
      });
    });
  }

  updateVariant() {
    // This would need to be connected to product variant data
    // For now, this is a placeholder for the variant selection logic
  }
}

/**
 * Add to Cart AJAX
 */
async function addToCart(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    
    if (!response.ok) throw new Error('Add to cart failed');
    
    const item = await response.json();
    
    // Update cart count
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = 'flex';
    });
    
    // Open cart drawer
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      if (cartOverlay) cartOverlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    
    return item;
  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
}

// Handle product form submission
document.querySelectorAll('.product-form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';
    
    try {
      await addToCart(new FormData(form));
      submitBtn.textContent = 'Added!';
      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }, 2000);
    } catch (error) {
      submitBtn.textContent = 'Error - Try Again';
      submitBtn.disabled = false;
    }
  });
});

/**
 * Smooth scroll for anchor links
 */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

/**
 * Intersection Observer for animations
 */
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
};

const fadeInObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      fadeInObserver.unobserve(entry.target);
    }
  });
}, observerOptions);

document.querySelectorAll('.fade-in').forEach(el => {
  fadeInObserver.observe(el);
});
